<template>
  <hr class="relative my-4 border-neutral-300 dark:border-neutral-700" />
</template>
